import {
    Validators,
    AbstractControl,
    ValidatorFn,
    ValidationErrors,
  } from '@angular/forms';
  
  import { isPresent } from '../utils/is-present';
  
  export const accountNumber: ValidatorFn = (
    control: AbstractControl
  ): ValidationErrors | null => {
    if (isPresent(Validators.required(control))) {
      return null;
    }
  
    const v: string = control.value;
    return /^[A-Za-z0-9 -]*[A-Za-z0-9][A-Za-z0-9 -]*$/g.test(v)
      ? null
      : { accountNumber: true };
  };
  